export default function LinkCard(props) {
  return (
    <a
      target="_blank"
      href={props.link}
      rel="noreferrer"
      className={` ${props.col == 1 ? `md:col-start-5 md:col-end-9` : `md:col-start-9 md:col-end-13`} select-none caption group bg-[#e4e4e4] hover:bg-[#d1d1d1] dark:text-white/80 dark:bg-white/[.05] col-span-full dark:hover:bg-white/10 dark:hover:text-white flex items-center flex-row p-4 rounded-md game-border font-code font-light text-black dark:text-[#717179]`}>
      <p>{props.children}</p>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        className="h-3 w-3 ml-auto stroke-[3px] stroke-black/30 group-hover:stroke-black/50 dark:stroke-white/30 dark:group-hover:stroke-white">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
      </svg>
    </a>
  );
}